// Amplify configuration for the frontend

const amplifyConfig = {
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_AMPLIFY_DATA_GRAPHQL_ENDPOINT || '',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      defaultAuthMode: 'apiKey' as const,
    },
    REST: {
      dnsTest: {
        endpoint: process.env.REACT_APP_DNS_TEST_ENDPOINT || '',
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      },
    },
  },
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      loginWith: {
        email: true,
      },
    },
  },
};

export default amplifyConfig;
